/**
 * 
 * @param submissions 
 * @param transformData 
 * @param series 
 * @returns 
 */
export const entrepreneursObtainedFundsChartCalculation = (submissions: any, transformData: any, series: any) => {
    const calc = (value: string) => transformData.map(({name, key}: any) => ({
        name,
        y: submissions.filter((submission: any) => submission[key] === value).length
    }))
        

    return {
        chart: {
            type: 'bar',
        },
        title: {
            text: '% of entrepreneurs who obtained the funds',
            align: 'left',
        },
        xAxis: {
            categories: transformData.map((el: any) => el.name),
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.0f}%'
                }
            }
        },
        series: series.map(({value, name, color}: any) => ({
            type: 'column',
            name,
            data: calc(value),
            color,
        }))
    } as Highcharts.Options;
}